export default {"src":"/_next/static/media/image5.05a062f9.svg","height":122,"width":135,"blurWidth":0,"blurHeight":0};